import React from 'react';
import SafeSmartMatchingWizard from './SafeSmartMatchingWizard';

// Safety wrapper to handle React Router context issues
function SmartMatchingWizardWrapper() {
  try {
    return <SafeSmartMatchingWizard />;
  } catch (error) {

    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Smart Matching Wizard</h2>
          <p className="text-gray-600 mb-4">Please refresh the page to continue.</p>
          <button
            onClick={() => window.location.reload()}
            className="px-6 py-2 bg-orange-500 text-white font-bold rounded-lg hover:bg-orange-600"
          >
            Refresh Page
          </button>
        </div>
      </div>
    );
  }
}

export default SmartMatchingWizardWrapper;